import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import FeedDefault from './Default';
import FeedPlayful from './Playful';

function Feed(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  return isPlayfulStudentTheme ? <FeedPlayful {...props} /> : <FeedDefault {...props} />;
}

export { Feed };
export * from './feed-post';
